// extracted by mini-css-extract-plugin
module.exports = {"hero-priority":"hero-priority-single-author-m__hero-priority__1I8Nd"};